var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomInput',{attrs:{"field":Object.assign({}, _vm.deafult_input, {readonly: _vm.readonly, value: new String(_vm.value)})},on:{"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }